(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const safeStorage = {
    get(key) { try { return sessionStorage.getItem(key); } catch (_) { return null; } },
    set(key, value) { try { sessionStorage.setItem(key, value); } catch (_) {} },
    remove(key) { try { sessionStorage.removeItem(key); } catch (_) {} }
  };
  const read = key => { try { return JSON.parse(safeStorage.get(key)); } catch (_) { return null; } };
  const params = new URLSearchParams(location.search);
  const cookie = name => document.cookie.split('; ').find(row => row.startsWith(`${name}=`))?.split('=').slice(1).join('=') || '';
  const allowed = kind => {
    const privacy = window.Shopify?.customerPrivacy;
    const method = kind === 'ads' ? 'marketingAllowed' : 'analyticsProcessingAllowed';
    return !!privacy && typeof privacy[method] === 'function' && privacy[method]();
  };
  const captureAttribution = () => {
    const gclid = params.get('gclid');
    if (gclid && /^[\w.-]{1,256}$/.test(gclid)) {
      safeStorage.set('koval.gclid', gclid);
      if (allowed('ads')) document.cookie = `koval_gclid=${encodeURIComponent(gclid)}; Max-Age=7776000; Path=/; SameSite=Lax; Secure`;
    }
    if (!safeStorage.get('koval.landing')) {
      const landingParams = new URLSearchParams();
      ['gclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_term', 'utm_content'].forEach(key => { if (params.has(key)) landingParams.set(key, params.get(key)); });
      safeStorage.set('koval.landing', `${location.origin}${location.pathname}${landingParams.size ? '?' + landingParams : ''}`);
    }
    $$('[data-koval-gclid]').forEach(el => { el.value = safeStorage.get('koval.gclid') || decodeURIComponent(cookie('koval_gclid')); });
    $$('[data-koval-landing]').forEach(el => { el.value = safeStorage.get('koval.landing') || location.href; });
  };
  captureAttribution();
  document.addEventListener('visitorConsentCollected', captureAttribution);
  document.addEventListener('koval:privacy-ready', captureAttribution);
  document.addEventListener('error', event => {
    if (event.target instanceof HTMLImageElement && event.target.matches('[data-koval-image]')) event.target.hidden = true;
  }, true);
  $$('img[data-koval-image]').forEach(img => { if (img.complete && !img.naturalWidth) img.hidden = true; });

  const config = $('#koval-tracking-config')?.dataset || {};
  const ensureGoogleTag = () => {
    if (!allowed('analytics')) return;
    const id = config.ga4Id || config.adsId;
    if (!id) return;
    if (typeof window.gtag !== 'function') {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag('js', new Date());
      if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
        const script = document.createElement('script'); script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
        document.head.appendChild(script);
      }
    }
    if (config.ga4Id) window.gtag('config', config.ga4Id, { send_page_view: false });
    if (config.adsId && allowed('ads')) window.gtag('config', config.adsId, { send_page_view: false });
  };
  ensureGoogleTag();
  document.addEventListener('visitorConsentCollected', ensureGoogleTag);
  document.addEventListener('koval:privacy-ready', ensureGoogleTag);
  const contextParams = line => {
    const context = String(line || document.body.dataset.kovalContext || '');
    if (/memorial|church/i.test(context)) return { koval_sensitive_context: 'yes' };
    if (allowed('ads') && /estate|ranch|architectural|portrait|modern/i.test(context)) return { koval_remarketing_eligible: 'yes' };
    return {};
  };
  const event = (name, detail, line) => {
    if (allowed('analytics') && typeof window.gtag === 'function') window.gtag('event', name, { ...contextParams(line), ...detail });
  };
  let pageMeasured = false;
  const pageEvent = () => {
    if (!pageMeasured && allowed('analytics') && typeof window.gtag === 'function') {
      event('koval_page_view', { page_path: location.pathname }); pageMeasured = true;
    }
  };
  pageEvent(); document.addEventListener('visitorConsentCollected', pageEvent);
  document.addEventListener('koval:privacy-ready', pageEvent);
  const conversion = (label, detail) => {
    if (label && config.adsId && allowed('ads') && typeof window.gtag === 'function') window.gtag('event', 'conversion', { send_to: `${config.adsId}/${label}`, ...detail });
  };
  $$('a[href^="tel:"]').forEach(link => link.addEventListener('click', () => {
    event('koval_phone_click', { lead_type: 'phone_click', page_path: location.pathname });
    conversion(config.callLabel, { value: 0, currency: 'USD' });
  }));

  $$('[data-koval-form-config]').forEach(marker => {
    const form = marker.closest('form');
    const purpose = $('[data-koval-purpose]', form);
    const piece = $('[data-koval-piece]', form);
    const files = $('input[type="file"]', form);
    const details = $('[data-koval-message]', form);
    const buyer = $('[data-koval-buyer]', form);
    const lineField = $('[data-koval-line]', form);
    const requestField = $('[data-koval-request-id]', form);
    const fallbackContext = params.get('line') || marker.dataset.line || '';
    const normalizeLine = value => ({ 'memorial-bronze': 'memorial', 'church-cemetery-statuary': 'church', 'estate-fountains': 'estate', 'ranch-wildlife-bronze': 'ranch', 'architectural-stone': 'architectural', 'custom-portrait-bronze': 'portrait' }[value] || value || '');
    const selectedContext = () => /church|cemetery|memorial/i.test(buyer?.value || '') ? 'memorial' : normalizeLine(piece.selectedOptions[0]?.dataset.line || fallbackContext);

    const updatePurpose = () => {
      if (files) files.required = purpose.value === 'rendering';
      $$('[data-koval-rendering-choice]', form).forEach(select => { select.required = purpose.value === 'rendering'; });
      const requiredMark = $('[data-photo-required]', form);
      if (requiredMark) requiredMark.hidden = purpose.value !== 'rendering';
      // The live rendering form accepts an optional brief. Preserve the price
      // form's existing requirement when the buyer explicitly selects custom.
      details.required = purpose.value === 'price' && piece.value === 'custom';
      lineField.value = selectedContext();
    };
    if (params.get('form') === 'price') purpose.value = 'price';
    if (params.has('piece') && [...piece.options].some(option => option.value === params.get('piece'))) piece.value = params.get('piece');
    if (params.has('project')) details.value = `Project: ${params.get('project')}\n`;
    purpose.addEventListener('change', updatePurpose);
    piece.addEventListener('change', updatePurpose);
    buyer?.addEventListener('change', updatePurpose);
    updatePurpose();
    $$('[data-koval-request]').forEach(link => link.addEventListener('click', () => { purpose.value = link.dataset.kovalRequest; updatePurpose(); form.dispatchEvent(new Event('change', { bubbles: true })); }));
    let started = false;
    form.addEventListener('focusin', () => {
      if (!started) {
        started = true;
        const context = contextParams(selectedContext());
        const detail = { lead_type: purpose.value, page_path: location.pathname };
        if (purpose.value === 'rendering' && context.koval_remarketing_eligible === 'yes') detail.koval_form_started = 'rendering';
        event('koval_form_start', detail, selectedContext());
      }
    });
    form.addEventListener('hok:inquiry-prepare', () => { updatePurpose(); captureAttribution(); });
  });
  $$('.kv-menu, .kv-mobile-menu').forEach(menu => {
    menu.addEventListener('toggle', () => { if (menu.open) $$('.kv-menu, .kv-mobile-menu').forEach(other => { if (other !== menu) other.open = false; }); });
  });
  document.addEventListener('keydown', key => {
    if (key.key === 'Escape') $$('.kv-menu[open], .kv-mobile-menu[open]').forEach(menu => { menu.open = false; $('summary', menu)?.focus(); });
  });
  document.addEventListener('click', click => {
    $$('.kv-menu[open], .kv-mobile-menu[open]').forEach(menu => { if (!menu.contains(click.target)) menu.open = false; });
  });
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
      if (!error) document.dispatchEvent(new Event('koval:privacy-ready'));
    });
  }
  const galleryLinks = $$('[data-koval-gallery]');
  if (galleryLinks.length && typeof HTMLDialogElement !== 'undefined') {
    const dialog = document.createElement('dialog'); dialog.className = 'kv-lightbox';
    dialog.innerHTML = '<button type="button" aria-label="Close enlarged image">Close ×</button><img alt="">';
    document.body.appendChild(dialog);
    const close = $('button', dialog), img = $('img', dialog);
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); });
    galleryLinks.forEach(link => link.addEventListener('click', click => { click.preventDefault(); img.src = link.href; img.alt = $('img', link).alt; dialog.showModal(); }));
  }
})();
